var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemindMeLater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-remind-me-later",
    transform: "translate(-1061.527 -76.04)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6379",
    "data-name": "Rectangle 6379",
    width: 20,
    height: 20,
    transform: "translate(1061.527 76.04)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "notifications_black_24dp",
    d: "M12,22a2.006,2.006,0,0,0,2-2H10A2,2,0,0,0,12,22Zm6-6V11c0-3.07-1.64-5.64-4.5-6.32V4a1.5,1.5,0,0,0-3,0v.68C7.63,5.36,6,7.92,6,11v5L4,18v1H20V18Z",
    transform: "translate(1059.527 73.54)",
    fill: "#00af9a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemindMeLater);
export default __webpack_public_path__ + "static/media/icon-remind-me-later.eaa82c39.svg";
export { ForwardRef as ReactComponent };